import { AnySchema } from 'yup';

interface AffiliatedDate {
    date: string;
    timezone: string;
    timezone_type: number;
}

export interface Affiliated {
    codSouscrip: any;
    codAffilie: string;
    categorie: string;
    dtAnniversaire: string;
    dtDebut: AffiliatedDate;
    dtDebutValidite: AffiliatedDate;
    dtEmbauche: string | any;
    dtFin: AffiliatedDate;
    dtFinValidite: AffiliatedDate;
    lbCollege: string;
    lbContrat: string;
    lbProduit: string;
    matriculeEntreprise: string;
    nom: string;
    nomJeuneFille: string;
    nomSouscripteur: string;
    numSecu: string;
    prenom: string;
    raisonSociale: string;
    sexe: string;
    siret: string;
    status: string;
    risque: string;
    ayantDroit: string;
    lbStatut: string;
    blAlert?: string;
}

export interface AffiliatedSingle {
    affilie: {
        id: number;
        numSecu: string;
        nom: string;
        prenom: string;
        nomJeuneFille: string;
        dtAnniversaire: string;
        sexe: string;
        adresse: string;
        codePostal: string;
        ville: string;
        cod: string;
        createdAt: string;
        modifiedAt: string;
    };
}

export interface Contract {
    idContract: string;
}
export interface RadiationForm {
    codAffilie: string;
    codSouscrip: string;
    motif: RadiationReason;
    dateEffective: Date;
    portability: string;
    contracts: Contract[];
}

export interface DataRadiation {
    contracts: Contract[];
    portability: number;
    dateEffective: string;
    motif: string;
    codSouscrip: string;
    codAffilie: string;
}

export interface RadiationNotif {
    id: string;
    data: DataRadiation;
}

export enum RadiationReason {
    CMU = 'radiate.reason.cmu',
    DECEASE = 'radiate.reason.decease',
    RESIGNATION = 'radiate.reason.resignation',
    CONTRACT_END_WITH_INDEMNISATION = 'radiate.reason.contract-end-indemnisation',
    CONTRACT_END_WITHOUT_INDEMNISATION = 'radiate.reason.contract-end',
    RETIREMENT = 'radiate.reason.retirement',
    SUSPENSION = 'radiate.reason.suspension',
}

export const initAffiliated = {
    categorie: '',
    codAffilie: '',
    dtAnniversaire: '',
    dtDebut: { date: '', timezone: '', timezone_type: 0 },
    dtDebutValidite: { date: '', timezone: '', timezone_type: 0 },
    dtEmbauche: '',
    dtFin: { date: '', timezone: '', timezone_type: 0 },
    dtFinValidite: { date: '', timezone: '', timezone_type: 0 },
    lbCollege: '',
    lbContrat: '',
    lbProduit: '',
    matriculeEntreprise: '',
    nom: '',
    nomJeuneFille: '',
    codSouscrip: '',
    nomSouscripteur: '',
    numSecu: '',
    prenom: '',
    raisonSociale: '',
    sexe: '',
    siret: '',
    status: '0',
    risque: '',
    ayantDroit: '',
    lbStatut: '',
};

export interface RadiationNewEvent {
    affilie: any;
    hasError: any;
    souscrip: AnySchema;
    subscriptions;
}
